import * as i0 from '@angular/core';
import { inject, Injectable, input, output, DestroyRef, signal, effect, Component, computed } from '@angular/core';
import { HmfTextLinkComponent, HmfAccordionComponent, HmfAlertBannerComponent, HmfSkeletonComponent, HmfDividerComponent } from '@dsg-tech/homefield-angular';
import * as i1 from '@dsg-tech/homefield-angular-icons';
import { homefieldIconArrowUpRightBoxed, HomefieldIconLibraryModule, HomefieldIconsLibraryService, homefieldIconSecurityVerifiedUser } from '@dsg-tech/homefield-angular-icons';
import { map, catchError, throwError, tap, of } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
const WarrantyInfoComponent_Defer_3_DepsFn = () => [HmfTextLinkComponent, HmfAccordionComponent, HmfAlertBannerComponent];
function WarrantyInfoComponent_Defer_1_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 2)(1, "p", 14);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r0.mainTitle());
  }
}
function WarrantyInfoComponent_Defer_1_Conditional_0_For_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 15);
    i0.ɵɵlistener("click", function WarrantyInfoComponent_Defer_1_Conditional_0_For_10_Template_a_click_0_listener() {
      const link_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.handleAnalytics(link_r3));
    })("keydown.enter", function WarrantyInfoComponent_Defer_1_Conditional_0_For_10_Template_a_keydown_enter_0_listener() {
      const link_r3 = i0.ɵɵrestoreView(_r2).$implicit;
      const ctx_r0 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r0.handleAnalytics(link_r3));
    });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const link_r3 = ctx.$implicit;
    i0.ɵɵproperty("linkURL", link_r3.link)("classList", "hmf-body-bold-s info-link");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", link_r3.text, " ");
  }
}
function WarrantyInfoComponent_Defer_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WarrantyInfoComponent_Defer_1_Conditional_0_Conditional_0_Template, 3, 1, "div", 2);
    i0.ɵɵelementStart(1, "div", 3);
    i0.ɵɵelement(2, "img", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 5)(4, "p", 6);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelement(6, "div", 7);
    i0.ɵɵelementStart(7, "div", 8)(8, "div", 9);
    i0.ɵɵrepeaterCreate(9, WarrantyInfoComponent_Defer_1_Conditional_0_For_10_Template, 2, 3, "a", 10, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(11, "div", 11)(12, "hmf-accordion", 12);
    i0.ɵɵelement(13, "div", 13);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r0.displayMainTitle() ? 0 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("src", ctx_r0.logoSrc(), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r0.subheadText());
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.bodyContent(), i0.ɵɵsanitizeHtml);
    i0.ɵɵadvance(3);
    i0.ɵɵrepeater(ctx_r0.links());
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("className", "hmf-legal-s")("label", ctx_r0.disclaimerTitle())("expandOverContent", false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("innerHTML", ctx_r0.disclaimerBody(), i0.ɵɵsanitizeHtml);
  }
}
function WarrantyInfoComponent_Defer_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1)(1, "hmf-alert-banner", 16)(2, "a", 17);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("className", "error-message-alert")("type", "alert")("title", ctx_r0.errorMessage.title)("message", ctx_r0.errorMessage.body);
    i0.ɵɵadvance();
    i0.ɵɵproperty("className", "hmf-body-s error-message-link")("linkURL", ctx_r0.errorMessage.linkURL);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.errorMessage.linkText, " ");
  }
}
function WarrantyInfoComponent_Defer_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, WarrantyInfoComponent_Defer_1_Conditional_0_Template, 14, 8)(1, WarrantyInfoComponent_Defer_1_Conditional_1_Template, 4, 7, "div", 1);
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵconditional(!ctx_r0.displayInnerErrorState() ? 0 : 1);
  }
}
function WarrantyInfoComponent_DeferPlaceholder_2_For_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "hmf-skeleton", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵproperty("loading", true)("borderRadius", 4)("width", "75%");
  }
}
function WarrantyInfoComponent_DeferPlaceholder_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "hmf-skeleton", 18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "div", 1);
    i0.ɵɵelement(3, "hmf-skeleton", 19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 1);
    i0.ɵɵelement(5, "hmf-skeleton", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵrepeaterCreate(6, WarrantyInfoComponent_DeferPlaceholder_2_For_7_Template, 2, 3, "div", 1, i0.ɵɵrepeaterTrackByIndex);
    i0.ɵɵelementStart(8, "div", 21);
    i0.ɵɵelement(9, "hmf-skeleton", 20)(10, "hmf-skeleton", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "div", 1);
    i0.ɵɵelement(12, "hmf-skeleton", 20);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("loading", true)("borderRadius", 4)("width", "35%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("loading", true)("borderRadius", 4)("width", "100%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("loading", true)("borderRadius", 4)("width", "40%");
    i0.ɵɵadvance();
    i0.ɵɵrepeater(ctx_r0.repeatedSkeletonFields);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("loading", true)("borderRadius", 4)("width", "100%");
    i0.ɵɵadvance();
    i0.ɵɵproperty("loading", true)("borderRadius", 4)("width", "100%");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("loading", true)("borderRadius", 4)("width", "40%");
  }
}
function PurchaseWarrantyComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 1);
    i0.ɵɵelement(1, "hmf-alert-banner", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("title", ctx_r0.planUpdateAlert().messageTitle)("message", ctx_r0.planUpdateAlert().messageBody)("type", ctx_r0.planUpdateAlert().messageType);
  }
}
function PurchaseWarrantyComponent_Conditional_9_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(" | Qty: " + ctx_r0.purchaseWarrantyData().warrantyQuantity);
  }
}
function PurchaseWarrantyComponent_Conditional_10_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span")(1, "a", 9);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("linkURL", ctx_r0.purchaseWarrantyData().infoLink)("altText", ((tmp_3_0 = ctx_r0.purchaseWarrantyData().infoLinkLabel) == null ? null : tmp_3_0.includes("learn")) ? `Learn more` : "\xB4Need to start a claim?\xB4")("endIconName", !ctx_r0.purchaseWarrantyData().subText ? "arrow-up-right-boxed" : "")("variant", "tertiary")("size", "small")("classList", "hmf-legal-s label-base-subtle purchase-warranty-info-link-fs");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.purchaseWarrantyData().infoLinkLabel, " ");
  }
}
function PurchaseWarrantyComponent_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "p", 7);
    i0.ɵɵtext(1);
    i0.ɵɵtemplate(2, PurchaseWarrantyComponent_Conditional_10_Conditional_2_Template, 3, 7, "span");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.purchaseWarrantyData().subText, " ");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r0.purchaseWarrantyData().infoLinkLabel && ctx_r0.purchaseWarrantyData().infoLink ? 2 : -1);
  }
}
let WarrantyInfoDao = /*#__PURE__*/(() => {
  class WarrantyInfoDao {
    constructor() {
      this.http = inject(HttpClient);
      this.httpOptions = {
        headers: new HttpHeaders({
          'Accept': 'application/json',
          // ecomm has it's own enum for these, do we need to import that?
          // 'Content-Type': 'application/json', // same as line above
          'Access-Control-Allow-Origin': '*',
          'Cache-Control': 'no-cache,no-store,must-revalidate,max-age=0',
          // seem to be default ecomm settings, same here?
          'Pragma': 'no-cache',
          'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
          // ecomm has more custom headers for timeout, centrasite key, and environment; waiting till we know more about AKS to implement those
        })
      };
      this.warrantyInfoPath = '/graphql/execute.json/global/warranty_by_id';
    }
    getWarrantyInfo(aemContentId) {
      return this.http.get(`${this.warrantyInfoPath};id=${aemContentId}`, this.httpOptions);
    }
    static {
      this.ɵfac = function WarrantyInfoDao_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WarrantyInfoDao)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WarrantyInfoDao,
        factory: WarrantyInfoDao.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return WarrantyInfoDao;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let WarrantyInfoService = /*#__PURE__*/(() => {
  class WarrantyInfoService {
    constructor() {
      this.warrantyInfoDao = inject(WarrantyInfoDao);
    }
    getWarrantyInfo(aemContentId) {
      return this.warrantyInfoDao.getWarrantyInfo(aemContentId).pipe(map(response => response.data), catchError(err => {
        return throwError(() => new Error(err));
      }));
    }
    static {
      this.ɵfac = function WarrantyInfoService_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WarrantyInfoService)();
      };
    }
    static {
      this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
        token: WarrantyInfoService,
        factory: WarrantyInfoService.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return WarrantyInfoService;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
var ErrorMessageEnum = /*#__PURE__*/function (ErrorMessageEnum) {
  ErrorMessageEnum["title"] = "Oops! Something Went Wrong";
  ErrorMessageEnum["body"] = "We encountered an issue loading the protection plan options. Please refresh the page and try again. If the problem persists, ";
  ErrorMessageEnum["linkText"] = "please contact support";
  ErrorMessageEnum["linkURL"] = "https://www.dickssportinggoods.com/s/help-desk";
  return ErrorMessageEnum;
}(ErrorMessageEnum || {});
let WarrantyInfoComponent = /*#__PURE__*/(() => {
  class WarrantyInfoComponent {
    constructor(homefieldIconsLibraryService) {
      /** INPUTS */
      this.aemContentIdentifier = input();
      this.displayMainTitle = input.required();
      /** OUTPUTS */
      this.displayErrorState = output();
      this.infoLinkClicked = output();
      this.warrantyInfoService = inject(WarrantyInfoService);
      this.destroyRef = inject(DestroyRef);
      this.loading = signal(false);
      this.logoSrc = signal('');
      this.mainTitle = signal('');
      this.subheadText = signal('');
      this.bodyContent = signal(null);
      this.links = signal([]);
      this.disclaimerTitle = signal('');
      this.disclaimerBody = signal(null);
      this.repeatedSkeletonFields = [0, 1, 2];
      this.displayInnerErrorState = signal(false);
      this.errorMessage = ErrorMessageEnum;
      this.aemContentIdEffect = effect(() => {
        const id = this.aemContentIdentifier();
        if (id) {
          this.getAemContent(id);
        }
      });
      homefieldIconsLibraryService.registerIcons([homefieldIconArrowUpRightBoxed]);
    }
    setViewContent(data) {
      const mainItem = data.warrantyInformationList.items[0];
      if (!mainItem) {
        // Leaving this console here to notice consumers when no data were retrieved from endpoint as it won't show anything on the screen
        console.error('No data to be shown for the provided aemContentIdentifier');
        this.displayErrorState.emit(true);
        this.displayInnerErrorState.set(true);
        return;
      }
      const s7Url = mainItem.logo?._dmS7Url ? mainItem.logo?._dmS7Url + '?wid=200' : null;
      this.logoSrc.set(s7Url ?? mainItem.logo?._dynamicUrl ?? mainItem.logo?._path);
      this.mainTitle.set(mainItem.title);
      this.subheadText.set(mainItem.subheadText);
      this.bodyContent.set(mainItem.body.html);
      this.links.set(mainItem.links);
      this.disclaimerTitle.set(mainItem.disclaimerTitle);
      this.disclaimerBody.set(mainItem.disclaimerBody.html);
    }
    getAemContent(id) {
      this.loading.set(true);
      this.warrantyInfoService.getWarrantyInfo(id).pipe(takeUntilDestroyed(this.destroyRef), tap(response => this.setViewContent(response)), tap(() => this.loading.set(false)), catchError(error => {
        this.displayErrorState.emit(true);
        this.displayInnerErrorState.set(true);
        this.loading.set(false);
        return of(new Error(error));
      })).subscribe();
    }
    handleAnalytics(link) {
      this.infoLinkClicked.emit(link);
    }
    static {
      this.ɵfac = function WarrantyInfoComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || WarrantyInfoComponent)(i0.ɵɵdirectiveInject(i1.HomefieldIconsLibraryService));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: WarrantyInfoComponent,
        selectors: [["non-merch-common-externals-warranty-info"]],
        inputs: {
          aemContentIdentifier: [1, "aemContentIdentifier"],
          displayMainTitle: [1, "displayMainTitle"]
        },
        outputs: {
          displayErrorState: "displayErrorState",
          infoLinkClicked: "infoLinkClicked"
        },
        decls: 6,
        vars: 1,
        consts: [["id", "aem-warranty-info-container", 1, "hmf-py-xs"], [1, "hmf-mb-s"], ["id", "warranty-info-title-text", 1, "hmf-mb-s"], ["id", "warranty-info-logo-container", 1, "logo-container", "hmf-mb-s"], ["alt", "Logo", 3, "src"], ["id", "warranty-info-subhead-text", 1, "hmf-mb-s"], [1, "hmf-body-m"], ["id", "warranty-info-body-content", 1, "hmf-mb-s", "hmf-body-s", 3, "innerHTML"], ["id", "warranty-info-links", 1, "hmf-mb-s", "hmf-body-bold-s"], [1, "hmf-flex-row", "flex-items-gap"], ["hmf-text-link", "", "altText", "link's alt text", "dataEm", "dateEM_tag", "ariaLabel", "An Aria label", "endIconName", "arrow-up-right-boxed", "target", "blank", "tabindex", "-1", 3, "linkURL", "classList"], ["id", "warranty-info-coverage-information"], ["id", "coverage-information-accordion", "size", "small", 3, "className", "label", "expandOverContent"], [1, "disclaimer-body", "hmf-body-l-m", 3, "innerHTML"], [1, "hmf-header-bold-s"], ["hmf-text-link", "", "altText", "link's alt text", "dataEm", "dateEM_tag", "ariaLabel", "An Aria label", "endIconName", "arrow-up-right-boxed", "target", "blank", "tabindex", "-1", 3, "click", "keydown.enter", "linkURL", "classList"], [3, "className", "type", "title", "message"], ["id", "error-message-link", "hmf-text-link", "", "target", "blank", "size", "small", 3, "className", "linkURL"], ["height", "8rem", 3, "loading", "borderRadius", "width"], ["height", "4rem", 3, "loading", "borderRadius", "width"], [3, "loading", "borderRadius", "width"], [1, "link-section-skeleton-layout", "flex-items-gap", "hmf-mb-s"]],
        template: function WarrantyInfoComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, WarrantyInfoComponent_Defer_1_Template, 2, 1)(2, WarrantyInfoComponent_DeferPlaceholder_2_Template, 13, 18);
            i0.ɵɵdefer(3, 1, WarrantyInfoComponent_Defer_3_DepsFn, null, 2);
            i0.ɵɵelement(5, "hmf-divider");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(3);
            i0.ɵɵdeferWhen(ctx.aemContentIdentifier() && !ctx.loading());
          }
        },
        dependencies: [HomefieldIconLibraryModule, HmfSkeletonComponent, HmfDividerComponent],
        styles: ["[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]     .hmf-accordion{min-width:unset}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]     .hmf-accordion button{border:none;box-sizing:border-box;color:var(--hmf-label-base-subtle);display:flex;justify-content:flex-start;outline:none;padding:0!important}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]     .hmf-accordion button :nth-child(1){font-size:var(--typography-body-links-small-size, 12px);font-weight:lighter}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]     .hmf-accordion button svg path{fill:var(--hmf-label-base-subtle)}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]     .hmf-accordion .hmf-accordion-content{border:none;color:var(--hmf-label-base-subtle);padding:0 var(--hmf-xs)!important}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]     .hmf-accordion .hmf-accordion-content .disclaimer-body p:first-child{margin-top:0}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]     .hmf-accordion .hmf-accordion-content .disclaimer-body a{color:var(--hmf-label-base-subtle);text-decoration:underline;text-underline-offset:2px!important}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]     .hmf-accordion .hmf-accordion-label-and-control, [_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]     .hmf-accordion .hmf-accordion-label-and-control:hover{background:unset}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]   .error-message-alert[_ngcontent-%COMP%]   .error-message-link[_ngcontent-%COMP%]{font-size:11px!important;font-weight:var(--typography-body-links-weights-regular, 400)!important;text-underline-offset:2px}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]   .flex-items-gap[_ngcontent-%COMP%]{gap:var(--hmf-s)}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]   .info-link[_ngcontent-%COMP%]{text-underline-offset:2px}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]   .link-section-skeleton-layout[_ngcontent-%COMP%]{display:grid;grid-template-columns:20% 20%}[_nghost-%COMP%]   #aem-warranty-info-container[_ngcontent-%COMP%]   .logo-container[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:40px}"]
      });
    }
  }
  return WarrantyInfoComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let PurchaseWarrantyComponent = /*#__PURE__*/(() => {
  class PurchaseWarrantyComponent {
    constructor() {
      this.homefieldIconsLibraryService = inject(HomefieldIconsLibraryService);
      this.purchaseWarrantyData = input.required();
      this.alertMessage = input('');
      this.displayAlert = computed(() => !!this.alertMessage());
      // Plan Update Alert Message
      this.planUpdateAlert = computed(() => {
        return {
          messageTitle: 'Plan Updated',
          messageBody: this.alertMessage(),
          messageType: 'warn'
        };
      });
      this.homefieldIconsLibraryService.registerIcons([homefieldIconSecurityVerifiedUser, homefieldIconArrowUpRightBoxed]);
    }
    static {
      this.ɵfac = function PurchaseWarrantyComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || PurchaseWarrantyComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: PurchaseWarrantyComponent,
        selectors: [["non-merch-common-externals-purchase-warranty"]],
        inputs: {
          purchaseWarrantyData: [1, "purchaseWarrantyData"],
          alertMessage: [1, "alertMessage"]
        },
        decls: 11,
        vars: 6,
        consts: [[1, "warranty-container", "background-base-subtle", "hmf-flex-column", "hmf-p-s"], [1, "hmf-mb-s"], [1, "hmf-display-flex", "hmf-w-100"], ["width", "16px", "height", "16px", "name", "security-verified-user", "fill", "var(--hmf-label-positive)", 1, "hmf-mr-xxs", "hmf-display-flex"], [1, "hmf-flex-column"], [1, "hmf-body-bold-s", "hmf-my-0"], [1, "hmf-body-s", "hmf-my-0", "label-base-subtle"], [1, "sub-text", "hmf-legal-s", "hmf-mt-s", "hmf-mb-0", "label-base-subtle"], [3, "title", "message", "type"], ["hmf-text-link", "", "dataEm", "dateEM_tag", "ariaLabel", "An Aria label", "target", "blank", "tabindex", "-1", 1, "purchase-warranty-link", 3, "linkURL", "altText", "endIconName", "variant", "size", "classList"]],
        template: function PurchaseWarrantyComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, PurchaseWarrantyComponent_Conditional_1_Template, 2, 3, "div", 1);
            i0.ɵɵelementStart(2, "div", 2);
            i0.ɵɵelement(3, "homefield-icon", 3);
            i0.ɵɵelementStart(4, "div", 4)(5, "p", 5);
            i0.ɵɵtext(6);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(7, "p", 6);
            i0.ɵɵtext(8);
            i0.ɵɵtemplate(9, PurchaseWarrantyComponent_Conditional_9_Template, 2, 1, "span");
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(10, PurchaseWarrantyComponent_Conditional_10_Template, 3, 2, "p", 7);
            i0.ɵɵelementEnd()()();
          }
          if (rf & 2) {
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.displayAlert() ? 1 : -1);
            i0.ɵɵadvance(5);
            i0.ɵɵtextInterpolate(ctx.purchaseWarrantyData().planDisplayName);
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate2(" ", ctx.purchaseWarrantyData().warrantyPeriod, " | ", ctx.purchaseWarrantyData().sellingPrice, " ");
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.purchaseWarrantyData().warrantyQuantity > 0 ? 9 : -1);
            i0.ɵɵadvance();
            i0.ɵɵconditional(ctx.purchaseWarrantyData().subText || ctx.purchaseWarrantyData().infoLinkLabel ? 10 : -1);
          }
        },
        dependencies: [HomefieldIconLibraryModule, i1.HomefieldIconsLibraryComponent, HmfAlertBannerComponent, HmfTextLinkComponent, CommonModule],
        styles: [".sub-text[_ngcontent-%COMP%]{font-style:italic}.purchase-warranty-info-link-fs[_ngcontent-%COMP%]{font-style:normal}.warranty-container[_ngcontent-%COMP%]{box-sizing:border-box;width:100%}"]
      });
    }
  }
  return PurchaseWarrantyComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ErrorMessageEnum, PurchaseWarrantyComponent, WarrantyInfoComponent, WarrantyInfoDao, WarrantyInfoService };
